<app-branches-form
  [edit]="false"
  [create]="true"
  [delete]="false"
  [details]="false"
  [access]="access()"
></app-branches-form>
